import instance from './BaseAPI';

let api = instance.Api;

export function requestGetInstitutionById(institutionSub, requestFunc, fetchedFunc) {
  return dispatch => {
    dispatch(requestFunc());

    api.get('/admin/institutions/' + institutionSub).then(
      response => dispatch(fetchedFunc(true, response.data))
    ).catch(
      err => {
        console.log(err);
        dispatch(fetchedFunc(false, err))
      }
    );
  }
}

export function requestGetInstitutions(requestFunc, fetchedFunc, lastEvaluatedKey = null) {
  return dispatch => {
    dispatch(requestFunc());

    api.get('/admin/institutions').then(
      response => {
        dispatch(fetchedFunc(true, response.data));
      }
    ).catch(
      err => {
        console.log(err);
        dispatch(fetchedFunc(false, err))
      }
    );
  }
}

/**
 * 施設情報の更新.
 * ※Cognitoも更新されます.
 *
 * @export
 * @param {*} institutionSub
 * @param {*} body
 * @param {*} requestFunc
 * @param {*} fetchedFunc
 * @returns
 */
export function requestUpdateInstitution(institutionSub, body, requestFunc, fetchedFunc) {
  return dispatch => {
    dispatch(requestFunc());

    api.put('/admin/institutions/' + institutionSub, body).then(
      response => dispatch(fetchedFunc(true, response.data))
    ).catch(
      err => {
        console.log(err);
        dispatch(fetchedFunc(false, err))
      }
    );
  }
}

/**
 * ID(institution_id)指定してEnable
 *
 * @export
 * @param {*} institutionId
 * @param {*} requestFunc
 * @param {*} fetchedFunc
 * @returns
 */
export function requestEnableInstitutionById(institutionId, requestFunc, fetchedFunc) {
  return dispatch => {
    dispatch(requestFunc());

    api.post('/admin/institutions/' + institutionId + '/enable').then(
      response => dispatch(fetchedFunc(true, response.data))
    ).catch(
      err => {
        console.log(err);
        dispatch(fetchedFunc(false, err))
      }
    );
  }
}

/**
 * ID(institution_id)指定してDisable
 *
 * @export
 * @param {*} institutionId
 * @param {*} requestFunc
 * @param {*} fetchedFunc
 * @returns
 */
export function requestDisableInstitutionById(institutionId, requestFunc, fetchedFunc) {
  return dispatch => {
    dispatch(requestFunc());

    api.post('/admin/institutions/' + institutionId + '/disable').then(
      response => dispatch(fetchedFunc(true, response.data))
    ).catch(
      err => {
        console.log(err);
        dispatch(fetchedFunc(false, err))
      }
    );
  }
}




// WEBPACK FOOTER //
// ./src/api/Institution.js